import React from "react"
import { SearchSortBy } from "../../../../../features/algolia/api/types/search"
import CustomSelect from "../../../../../ui/atoms/CustomSelect"
import { useAlgoliaSearchState } from "../../controller/state"

export const OrderByDropdown = () => {
  const {
    orderByOptions,
    searchParams,
    updateSearchParams,
  } = useAlgoliaSearchState()

  const handleOrderByChange = (id: SearchSortBy) => {
    updateSearchParams((state) => ({
      ...state,
      orderBy: id,
    }))
  }

  return (
    <CustomSelect
      values={orderByOptions.map((x) => ({
        id: x.key,
        label: x.label,
      }))}
      value={searchParams.orderBy}
      onChange={handleOrderByChange}
      size="small"
    />
  )
}
